import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { FaSignInAlt } from "react-icons/fa";

export default function AlertLogin({ show, setShow }) {
    return (
        <Modal centered show={show} onHide={() => setShow(false)}>
            <Modal.Body>
                <div className="text-end fw-bold">
                    <AiOutlineClose style={{ fontSize: 22, cursor: "pointer" }} onClick={() => setShow(false)} />
                </div>
                <div className="h3 text-center p-4">กรุณาเข้าสู่ระบบก่อนใช้งาน</div>
                <div className="text-center mb-5">
                    <Link to="/login" style={{ fontSize: 20 }}>
                        <FaSignInAlt /> เข้าสู่ระบบ
                    </Link>
                </div>
            </Modal.Body>
        </Modal>
    );
}
